import { defineStore } from "pinia";

import EmployeesService, { Employee } from "@/services/apps/EmployeesService.ts";

type State = {
    employee: Employee | null;
    employeeLoading: boolean;
    bgColor: string | null;
};

export type App = "picking" | "completion" | "expedition" | "palletChecker";

export const appStore = defineStore("appStore", {
    state: (): State => ({
        employee: null,
        employeeLoading: false,
        bgColor: null,
    }),
    actions: {
        async signIn(app: App, employeeId: number): Promise<void> {
            this.employeeLoading = true;
            const tabletId = localStorage.getItem(`${app}TabletId`) || "";
            try {
                const employee = await EmployeesService.signIn(employeeId, parseInt(tabletId, 10));
                this.setEmployee(app, employee);
            } catch (e) {
                this.unsetEmployee(app);
                throw e;
            } finally {
                this.employeeLoading = false;
            }
        },
        async signOut(app: App): Promise<void> {
            if (!this.employee) return;

            const tabletId = localStorage.getItem(`${app}TabletId`) || "";
            await EmployeesService.signOut(this.employee.id, parseInt(tabletId, 10));
            this.unsetEmployee(app);
        },
        async autoSignIn(app: App): Promise<void> {
            const employeeId = localStorage.getItem(`${app}EmployeeId`) || "";
            const tabletId = localStorage.getItem(`${app}TabletId`) || "";
            if (employeeId && tabletId) {
                await this.signIn(app, parseInt(employeeId, 10));
            }
        },
        setEmployee(app: App, employee: Employee): void {
            this.employee = employee;
            localStorage.setItem(`${app}EmployeeId`, this.employee.id.toString());
        },
        unsetEmployee(app: App): void {
            this.employee = null;
            localStorage.removeItem(`${app}EmployeeId`);
        },
    },
    getters: {
        getEmployee: (state) => state.employee,
        isEmployeeLoading: (state) => state.employeeLoading,
    },
});
